module.exports = __webpack_public_path__ + "img/aperture.7d0c9ae9.svg";